import './styles-site.scss';

import Vue from 'vue';

import { loadComponents } from '@/Components/component-loader';
import { loadComponents as loadFeatureComponents } from '@/Features/features-loader';

import { initIconLibrary } from './utilities/icon-library';

initIconLibrary();

configureVue(Vue);

loadComponents();
loadFeatureComponents();

/**
 * @param {import('vue/types/vue').VueConstructor} vue
 */
function configureVue(vue) {
  vue.config.productionTip = false;

  vue.config.errorHandler = function (err, vm, info) {
    console.error(err, vm, info);
  };
}
